<template>
  <div class="focused-message">
    <div class="focused-message__view">
      <div class="focused-message__message">
        <slot name="message" />
      </div>

      <div class="focused-message__button">
        <slot name="button" />
      </div>
    </div>
  </div>
</template>

<style lang="less">
@import "@/abc-dsk/theming/index.less";

.focused-message {
  &__view {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    height: 100vh;
  }

  &__message {
    padding-right: 20%;
    padding-left: 20%;
    color: rgb(@theme-colors[@secondary][base]);
    font-size: 24px;
    font-weight: 600;
    text-align: center;
  }
}
</style>
